<template>
  <div class="login-main">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm"
              status-icon>
      <el-form-item prop="userName">
        <el-input v-model="dataForm.userName" placeholder="帐号"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input v-model="dataForm.password"
                  type="password"
                  placeholder="密码"
                  show-password></el-input>
      </el-form-item>
      <el-form-item prop="captcha">
        <el-row :gutter="20">
          <el-col :span="14">
            <el-input v-model="dataForm.captcha" placeholder="验证码">
            </el-input>
          </el-col>
          <el-col :span="10" class="login-captcha">
            <img :src="captchaPath" @click="getCaptcha()" alt="">
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-button class="login-btn-submit" type="primary" @click="dataFormSubmit()">登录
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getUUID } from '@/util/common';
import { post } from '@/util/Http';
import { mapState, mapMutations } from 'vuex';

export default {
  data() {
    return {
      dataForm: {
        userName: '',
        password: '',
        uuid: '',
        captcha: '',
      },
      dataRule: {
        userName: [
          {
            required: true,
            message: '帐号不能为空',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: '密码不能为空',
            trigger: 'blur',
          },
        ],
        captcha: [
          {
            required: true,
            message: '验证码不能为空',
            trigger: 'blur',
          },
        ],
      },
      captchaPath: '',
    };
  },
  created() {
    this.getCaptcha();
  },
  computed: {
    ...mapState({
      isLogin: 'isLogin',
    }),
  },
  methods: {
    ...mapMutations([
      'updateLogin',
    ]),
    // 提交表单
    dataFormSubmit() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          post('/sys/login', {
            not: true,
            username: this.dataForm.userName,
            password: this.dataForm.password,
            uuid: this.dataForm.uuid,
            captcha: this.dataForm.captcha,
          })
            .then(({ data }) => {
              if (data && data.code === 0) {
                const { token } = data;
                this.$store.state.token = token;
                this.$store.state.isLogin = true;
                this.updateLogin({
                  isLogin: true,
                  token,
                });
              } else {
                this.getCaptcha();
                this.$message.error(data.msg);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    // 获取验证码
    getCaptcha() {
      this.dataForm.uuid = getUUID();
      this.captchaPath = `/${process.env.VUE_APP_API_URL}/captcha.jpg?uuid=${this.dataForm.uuid}`;
    },
  },
};
</script>

<style lang="less">

</style>
